import { useMemo, useState, type ReactNode } from 'react';

import { ExclusivePanelContext, type ExclusivePanel } from './ExclusivePanelContext';

/**
 * Provides the shared "active panel" signal that keeps the Layers, Filters, POI
 * and Stats sliding panels mutually exclusive. Scoped to the Find & Fix layout
 * so it wraps both the Stats panel and the <Outlet> that renders MapView.
 */
export function ExclusivePanelProvider({ children }: { children: ReactNode }) {
    const [activePanel, setActivePanel] = useState<ExclusivePanel | null>(null);
    const value = useMemo(() => ({ activePanel, setActivePanel }), [activePanel]);

    return <ExclusivePanelContext value={value}>{children}</ExclusivePanelContext>;
}
